export default __webpack_public_path__ + "static/blog-holder-3dea2f8dc30a98ea9b8f9eb1f45eb53d.png";